module.exports = __webpack_public_path__ + "img/barrier-and-car.e1a2e411.svg";